export { default } from './MarketingPageLayout';
export * from './MarketingPageLayout.types';
